module.exports = __webpack_public_path__ + "static/media/Tes-IQ.fb0e4c27.png";